import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertService, MemberListService ,AppService} from '../_services';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewsletterAnalyticalService } from '../_services/newsletter-analytical.service';

@Component({
  selector: 'app-newsletter-analytical',
  templateUrl: './newsletter-analytical.component.html',
  styleUrls: []
})

export class NewsletterAnalyticalComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {}; 
  dtTrigger = new Subject(); 

  newsletterAnalyticalList: any[] = []; // Table Data list
  closeResult: string; // Modal Close

  constructor(
              public router: Router,
              private dataService:NewsletterAnalyticalService,
              private alertService: AlertService,
              private AppService: AppService,
              private modalService: NgbModal
            ) { }
    
  modalReference:NgbActiveModal;
  modalTitle:string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.allMember();
  }

  allMember(){
    this.loadShow();
    this.dataService.getNewsLetterAnalytical()
        .pipe().subscribe(
          res => { this.newsletterAnalyticalList = res['data'];
          console.log(this.newsletterAnalyticalList); 
          this.rerender();
          this.loadHide();
      });
    }

  // delete(id){
  //   if(confirm("Are you sure you want to active/inactive the member")) {
  //     this.dataService.deleteMember(id)
  //         .pipe().subscribe(data =>{
  //           if(data['status']==200){
  //             this.alertService.success('Member status updated successfully', true);
  //             this.allMember();
  //           }else{
  //             this.alertService.error('Member error');
  //           }
  //         },error =>{
  //           this.alertService.error(error);
  //         });
  //   }
  // }
  
  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

}
